/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_Preview_ChoicesInputs */

const en_admin_questionnaire_editor_preview_choices = /** @type {(inputs: Admin_Questionnaire_Editor_Preview_ChoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview Choices`)
};

const nl_admin_questionnaire_editor_preview_choices = /** @type {(inputs: Admin_Questionnaire_Editor_Preview_ChoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keuzes bekijken`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_Preview_ChoicesInputs) => LocalizedString} */
const de_admin_questionnaire_editor_preview_choices = en_admin_questionnaire_editor_preview_choices;

/** @type {(inputs: Admin_Questionnaire_Editor_Preview_ChoicesInputs) => LocalizedString} */
const es_admin_questionnaire_editor_preview_choices = en_admin_questionnaire_editor_preview_choices;

/** @type {(inputs: Admin_Questionnaire_Editor_Preview_ChoicesInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_preview_choices = en_admin_questionnaire_editor_preview_choices;

/** @type {(inputs: Admin_Questionnaire_Editor_Preview_ChoicesInputs) => LocalizedString} */
const it_admin_questionnaire_editor_preview_choices = en_admin_questionnaire_editor_preview_choices;

/** @type {(inputs: Admin_Questionnaire_Editor_Preview_ChoicesInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_preview_choices = en_admin_questionnaire_editor_preview_choices;

/** @type {(inputs: Admin_Questionnaire_Editor_Preview_ChoicesInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_preview_choices = en_admin_questionnaire_editor_preview_choices;

/** @type {(inputs: Admin_Questionnaire_Editor_Preview_ChoicesInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_preview_choices = en_admin_questionnaire_editor_preview_choices;

/** @type {(inputs: Admin_Questionnaire_Editor_Preview_ChoicesInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_preview_choices = en_admin_questionnaire_editor_preview_choices;

/**
* | output |
* | --- |
* | "Preview Choices" |
*
* @param {Admin_Questionnaire_Editor_Preview_ChoicesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_preview_choices = /** @type {((inputs?: Admin_Questionnaire_Editor_Preview_ChoicesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_Preview_ChoicesInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_preview_choices(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_preview_choices(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_preview_choices(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_preview_choices(inputs)
	if (locale === "nl") return nl_admin_questionnaire_editor_preview_choices(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_preview_choices(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_preview_choices(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_preview_choices(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_preview_choices(inputs)
	return ro_admin_questionnaire_editor_preview_choices(inputs)
});
export { admin_questionnaire_editor_preview_choices as "admin.questionnaire_editor.preview_choices" }